module.exports = __webpack_public_path__ + "static/media/slides.a64be3f5.svg";